export default "__VITE_ASSET__B5gQz960__"